import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import icon from "../assets/ticket.png";
import Date from "./Date";
import Faq from "./Faq";
import Header from "./Header";
import Contact from "./Contact";
import { FaPhoneAlt } from "react-icons/fa";
import { IoClose } from "react-icons/io5";

const Home = () => {
  const [openModal, setOpenModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(true);

  useEffect(() => {
    setShowContactModal(true);
  }, []);

  return (
    <div className="overflow-x-hidden">


      {/* HERO SECTION */}
      <div
        className="w-full min-h-screen bg-no-repeat bg-cover bg-center relative"
        style={{
          backgroundImage: "url('https://i.ibb.co.com/fz4FG8WH/hero.png')",
        }}
      >

        {/* OVERLAY */}
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(180deg, rgba(0,6,40,0.85) 0%, rgba(0,35,102,0.88) 55%, rgba(0,10,50,0.9) 100%)",
          }}
        />

        <Header />

        {/* HERO CONTENT */}
        <div className="relative z-10 min-h-[calc(100vh-90px)] flex items-center justify-center px-4">

          <div className="max-w-4xl text-center text-white">

            <h2 className="text-2xl sm:text-4xl md:text-6xl font-extrabold uppercase drop-shadow-xl">
              PGiyan Reunion 2026
            </h2>

            <p className="text-xl sm:text-3xl md:text-5xl font-bold mt-6 text-blue-100 tracking-wide">
              Chatkhil PG Govt High School
            </p>

            <p className="mt-4 text-base md:text-xl italic text-sky-200 tracking-wide">
              “শুরুর সেই মাটিতে — স্মৃতির ডাক”
            </p>

            {/* Buttons */}
            <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">

              <Link
                to="/buy-ticket"
                className="px-6 md:px-8 py-3 rounded-full 
                bg-gradient-to-r from-blue-500 to-indigo-600 
                hover:from-indigo-600 hover:to-blue-700 
                transition font-semibold shadow-xl 
                flex items-center gap-2 justify-center text-sm md:text-base"
              >
                <img src={icon} alt="ticket" className="w-5 h-5" />
                Get a Ticket
              </Link>

              <button
                onClick={() => setOpenModal(true)}
                className="px-6 md:px-8 py-3 rounded-full border-2 border-blue-400 
                hover:bg-blue-500 transition font-semibold shadow-md text-sm md:text-base"
              >
                Learn More
              </button>

            </div>

          </div>
        </div>
      </div>

      {/* LEARN MORE MODAL */}
      {openModal && (
        <div className="fixed inset-0 z-[9999] bg-black/70 backdrop-blur-md flex items-center justify-center p-4 overflow-y-auto">

          <div className="bg-gradient-to-br from-blue-950 to-indigo-950 
          text-white rounded-3xl w-full max-w-3xl p-6 md:p-8 shadow-2xl 
          relative max-h-[90vh] overflow-y-auto">

            <button
              onClick={() => setOpenModal(false)}
              className="absolute top-4 right-4 text-xl hover:text-red-400"
            >
              ✕
            </button>

            <h3 className="text-xl md:text-3xl font-extrabold mb-4 text-center">
              PGiyan Reunion 2026
            </h3>

            <p className="text-sky-200 text-center mb-6 italic text-sm md:text-base">
              চলো ফিরে যাই আবার সেই প্রিয় আঙ্গিনায়
            </p>

            <div className="space-y-4 text-sm md:text-base leading-relaxed text-blue-100">

              <p>
                শেষ পিজিয়ান রিউনিয়ন অনুষ্ঠিত হয়েছিল ২০১৮ সালে। এরপর দীর্ঘ সময় পার হয়ে গেছে,
                আর আমরা সবাই মিলে আবার সেই উচ্ছ্বাসের মুহূর্তগুলো ভাগাভাগি করতে চাই।
              </p>

              <p>
                ২০২৬ সালে আমরা নতুন উদ্দীপনা ও একতায় সবাইকে একত্র করার চেষ্টা করছি।
                এটি শুধু একটি মিলনের আয়োজন নয়, বরং পুরনো বন্ধনগুলোকে আরও শক্তিশালী করার,
                স্মৃতিগুলোকে তাজা করার এবং নতুন গল্প তৈরি করার একটি সুযোগ।
              </p>

              <p>
                আশা করি এই রিউনিয়ন আমাদের সকলের জন্য আনন্দ, হাসি এবং স্মরণীয় মুহূর্তে পরিপূর্ণ হবে।
              </p>

              <p className="text-center font-semibold text-sky-300 pt-4">
                আমরা পিজিয়ান — আমরা পিজিয়ান — আমরা পিজিয়ান 🎶
              </p>

            </div>
          </div>
        </div>
      )}

      <Date />
      <Faq />
      <Contact />

    </div>
  );
};

export default Home;